import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, JobOperationActions, MasterConstants } from '../../Models/EnumModels';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MessagingService } from '../../Services/MessagingService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MessageDetail } from '../MessageDetail/MessageDetail';
import { untilDestroyed } from 'ngx-take-until-destroy';
import * as enumModels from '../../Models/EnumModels';

@Component({
    selector: 'NotificationCenter',
    templateUrl: './NotificationCenter.html'  
})

export class NotificationCenter extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('messageDetail') messageDetail: MessageDetail;

    Model = [];
    DateFormat: string;


    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public _messagingService: MessagingService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.onMessageCacheChanged();

        this._messagingService.MessageCacheChanged.pipe(untilDestroyed(this)).subscribe(() => {
            this.onMessageCacheChanged();
        });
    }

    onMessageCacheChanged(): void {
        this._messagingService.MessageCache.forEach(row => {
             row.EventDescription = this.masterService.MasterData_GetMutli(row.PropertyId, row.EventId, enumModels.EntityCodes.EventMaster, row.EventDescription);
        })
        this.Model = this._messagingService.MessageCache;
    }

    onMessageClick(Data:any): void {
        if (Data.IsRead == false)
            this._messagingService.Message_MarkAsRead(Data.MessageId);

        this.messageDetail.Open(Data);
    }

    onMessageDismiss(Data: any): void {
        if (Data.IsRead == false) {
            this._messagingService.Message_MarkAsRead(Data.MessageId).then(() => {
                this._messagingService.Message_Remove(Data.MessageId);
            });
        }
        else
            this._messagingService.Message_Remove(Data.MessageId);
    }

    onDismissAll(): void {
        let arr = [];
        let toUpdate = [];
        for (let i = 0; i < this.Model.length; i++) {
            arr.push(this.Model[i].MessageId);
            if (this.Model[i].IsRead == false) {
                toUpdate.push(this.Model[i].MessageId);
            }
        }

        if (toUpdate.length > 0) {
            this._messagingService.Message_MarkAsRead_Multi(toUpdate).then(() => {
                this._messagingService.Message_Remove_Multi(arr);
            });
        }
        else {
            this._messagingService.Message_Remove_Multi(arr);
        }
    }
    onClose(): void {
        this._messagingService.NC_Visiblity = false
    }
}
